const productCategory = [
    {
        id: 1,
        label: "Smart Phones",
        value: "smartphones"
    },
    {
        id: 2,
        label: "Tablets",
        value: "tablets"
    },
    {
        id: 3,
        label: "Smart Watches",
        value: "smart-watches"
    },
    {
        id: 4,
        label: "Laptops",
        value: "laptops"
    },
    {
        id: 5,
        label: "Drones",
        value: "drones"
    },
    {
        id: 6,
        label: "Accessories",
        value: "accessories"
    },
    {
        id: 7,
        label: "Games Consoles",
        value: "games-consoles"
    }
];

export default productCategory;